// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"333":"e59f5f73","661":"faae3f73"}[chunkId] + ".chunk.css";
};